/** 首页逻辑 - 极简备案页，仅营业执照弹窗交互。 */

/**
 * 绑定营业执照弹层开关。
 */
function initLicenseDialog() {
  const dialog = document.getElementById("license-dialog") as HTMLDialogElement | null;
  const openBtn = document.getElementById("btn-license");
  const closeBtn = document.getElementById("btn-license-close");
  if (!dialog || !openBtn || !closeBtn) {
    return;
  }

  openBtn.addEventListener("click", () => dialog.showModal());
  closeBtn.addEventListener("click", () => dialog.close());
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) {
      dialog.close();
    }
  });
}

initLicenseDialog();
